import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from 'd3';

import ScatterPlotGrid from "./ScatterPlotGrid";
import './ScatterPlot.css';
import HoverOver from "../HoverOver";

class ScatterPlot extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 300,
      height: 300
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    const maxHeight = this.props.maxHeight || width;
    this.setState({width: width, height: Math.min(maxHeight, width * .93)});
  }

  render() {
    const isSingleDim = this.props.type === 'x' || this.props.type === 'y';
    const width = this.state.width;
    const height = width > 150 ? (isSingleDim ? 90 : this.state.height) : 400;

    return (
      <div ref="wrapper" className="ScatterPlot" height={height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <ScatterPlotGrid
          width={width}
          height={height}
          titleX={this.props.titleX}
          titleY={this.props.titleY}
          dimX={this.props.dimX}
          dimY={this.props.dimY}
          dimId={this.props.dimId}
          year={this.props.year}
          type={this.props.type}
          data={this.props.data}
          onHoverOver={(fips, hover) => {
            this.setState({hover});
            d3.selectAll("#FIPS_" + fips).attr("class", "hover_over");
          }}
          onHoverOut={fips => {
            this.setState({hover: null});
            d3.selectAll("#FIPS_" + fips).attr("class", "hover_out");
          }}
          onClick={fips => {
            if (this.props.onClick) {
              this.props.onClick(fips);
            }
          }}
        />
        <HoverOver data={this.state.hover} top={22} bottom={22} left={30} right={30}/>
      </div>
    );
  }
}

ScatterPlot.propTypes = {
  titleX: PropTypes.string,
  titleY: PropTypes.string,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  dimId: PropTypes.string,
  year: PropTypes.number,
  type: PropTypes.string,
  data: PropTypes.array,
  onClick: PropTypes.func
};

export default ScatterPlot;


// WEBPACK FOOTER //
// ./src/charts/ScatterPlot/index.js